export default __webpack_public_path__ + "static/media/product-place-holder.51290a2a.svg";